import type { ReactNode } from 'react';
import { useState } from 'react';
import type { LoginDialogProps } from '../LoginDialog/LoginDialog.client';
import { LoginDialog } from '../LoginDialog/LoginDialog.client';

export interface LoginDialogComposedProps
  extends Omit<LoginDialogProps, 'children' | 'isOpen' | 'handleClose' | 'onClose'> {
  /** Render prop function, so children can control LoginDialog */
  children?: (showDialog: () => void) => ReactNode;
  isOpen?: boolean;
}

/** Composed component to include and control LoginDialog */
export const LoginDialogComposed = ({ children, ...dialogProps }: LoginDialogComposedProps) => {
  const [showLoginDialog, setShowLoginDialog] = useState(false);

  const openLoginDialog = () => setShowLoginDialog(true);
  const closeLoginDialog = () => {
    setShowLoginDialog(false);
  };

  return (
    <>
      <LoginDialog {...dialogProps} isOpen={showLoginDialog} handleClose={closeLoginDialog} />
      {children && children(openLoginDialog)}
    </>
  );
};
